export default __webpack_public_path__ + "static/media/050_brake.hevc.c8bc3a17.mp4";